<template>
  <div class="part news2" v-if="informationList.length">
    <div class="ele-title">
      <img
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/title-article.png"
        alt
      />
    </div>
    <div class="news2-content">
      <template v-for="(item, index) in informationList">
        <template>
          <div
            :href="item.subInfo3"
            @click="enterDetail(item)"
            class="list-item"
            :key="index"
          >
            <img v-lazy="item.subInfo4" :key="item.subInfo4" alt="" />
            <div class="info">
              <h5>
                {{ item.subInfo5 }}
              </h5>
              <p>{{ item.subInfo6 }}</p>
              <button>立即查看</button>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    informationList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  methods: {
    enterDetail (item) {
      // title, link, type, id
      this.setAnalytics('解放j6x|主页面|查看图文', item.subInfo7)
      this.toNews(item.subInfo5, item.subInfo3, item.subInfo1, item.subInfo7)
    }
  }
}
</script>
<style lang="less" scoped>
.news2 {
  .news2-content {
    z-index: 1;
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list-item {
      width: 338px;
      height: 569px;
      display: block;
      position: relative;
      z-index: 1;
      margin: 0;
      margin-top: 20px;
      background: url(https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/info-bg.png)
        no-repeat 50% 50%;
      display: block;
      padding: 25px 20px;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      img {
        width: 300px;
        height: 200px;
        margin: 0 auto;
        height: 200px;
        display: block;
        background: #efefef
          url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHMAAAApBAMAAAD0eAtEAAAAFVBMVEXv7+/R0dHX19fc3Nzp6eng4ODk5OQNpKnjAAACnElEQVRIx9WWTW/bMAyGPVvRuVQan2M16NnOx85O4u2cbPXdHrD8/5+wl6IVWcpQFOipLKCUlB69JSkGzT5nubUvUUBZazfeWRDREPa+Ea0iz0ToEafbj6LUi70pXuEb5w4/+v4XvAM72oWufq8V9G7rkeb2c+4UFNkQo0ZHu8/jR1DrrD5hqe5ut7XeBDW7yQRNy6QQLrPEjoIuvZ+i4dS+6+Ju0aRqJ0vQcMqk3Tpx4lE969DX6NTfBFWVNFrfKsaWt9utTVE5VS4SNHeisILoj6tE1wmrcctcdEjRyqfW0HPOaCGv7bwLdsAmOrD1bbiIqK/5mei7U21o48oSDIG4720keiKxsiDDO8fkhTTz1xSJchkkVxFFwh1o051JOq4QOCNwgwXRi+yMVObYE9FQ4SZ0a1YmVXMKq3vPh1z+nAgtRDZBcxOu1I2UkFJVkU3RisKN46yeMVqQPNLZ7LzmREFUNkhkIxSyqQ1zUTmBChuWjdEiJVcSWXsSLle4HEU2ecNxrg3Ayg/+C0gaGNV83/son32GI1Y33JUT0Ixl30NFtPXvbamh3KqKq6bxvgd3efoVrqdAB5s+3JT5s1/YXEbKpSM5LVAFhTkvdlnf/97hMUnMLa1GhZQEcx4qmWcto1m53q1RWzVNscTcoU1BS+w8ZfINU2HwD/1bNpr+Su2CNl3r0VK+kjXHeGkMur0noGLNKue7gaLJbcHv3aNPvtVrLNi4Aq3I3NEK6OUB7UZRbVN0jx9Br0RAiUyMvhJJrg9ofVaCKuQK9GVL6whd9Q3QFUrwgGYqzhXu/3P9DIo1QTNB8dh5tLDWR7KVcV+4ZtbXNV/AMd6gckLD/ysNxoohvv1kba1sjU9lYVmG38+WA/AGzfOG1/QP24+i/flJ+D4AAAAASUVORK5CYII=)
          no-repeat 50% 50%;
      }
      .info {
        color: #fff;
        text-align: center;
        flex: 1;
        position: relative;
        h5 {
          margin-top: 12px;
          font-size: 32px;
          font-weight: 500;
          color: #8be5ff;
          line-height: 42px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          max-height: 150 px;
        }
        p {
          margin-top: 14px;
          font-size: 22px;
          font-weight: 400;
          color: #8be5ff;
          line-height: 36px;
          opacity: 0.65;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          max-height: 100px;
        }
        button {
          position: absolute;
          left: 8px;
          bottom: 0;
          width: 280px;
          height: 90px;
          margin-top: 21px;
          font-size: 36px;
          font-weight: bold;
          color: #ffffff;
          line-height: 36px;
          background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/info-btn-read.png')
            no-repeat 50% 50%;
          cursor: pointer;
        }
      }
    }
  }
}
// pc按钮hover
@media screen and (min-width: 752px) {
  .news2-content {
    .list-item {
      .info {
        button {
          transition: 0.3s;
          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
</style>
